import { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  distroListData,
  distroData,
  listDistroListData,
  addDistroListEntry,
  removeDistroListEntry,
} from '../../store/DistributionList/actionCreator'
import { CircularProgress, TextField, Button } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import HeaderTitle from '../Header/HeaderTitle'
import { Helmet } from 'react-helmet'
import { formValidation } from '../MessageCreate/formValidation'
import DistributionListItems from '../DistributionList/DistributionListItems'
import { arrayOf, shape, string, func, bool, object } from 'prop-types'

const styles = (theme) => ({
  spinner: {
    color: theme.palette.primary.main,
  },
  homePage: {
    textAlign: 'center',
  },
  centerDiv: {
    margin: 'auto',
    padding: '0px',
    width: '20%',
    minWidth: 475,
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  button: {
    margin: theme.spacing(1),
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
})

export class DistributionListMaintenancePage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      distroListAddEntry: '',
      distroListAddEntryError: true,
      blossomID: this.props.blossomIDFromParent,
    }

    this.setDistroListData()
    this.handleChange = this.handleChange.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
  }

  handleChange(event) {
    const target = event.target
    const name = target.name
    const value = target.value

    this.setState({
      [name]: value,
    })

    if (name === 'distroListAddEntry') {
      if (formValidation(value, 'email', 'boolean') === false) {
        this.setState({
          distroListAddEntryError: false,
        })
      } else {
        this.setState({
          distroListAddEntryError: true,
        })
      }
    }
  }

  handleDelete = () => {
    let alertWindow = window.confirm(
      'Are you sure you want to delete this entry?',
    )
    if (alertWindow) {
      this.props.deleteTableRow(this.state.selected, this.props.tableName)
    }
    this.setState({ selected: [] })
    this.setState({ selectedId: 0 })
  }

  // New function initial load
  setDistroListData() {
    this.props.listDistroListData(this.state.blossomID)
  }

  removeDistroListEntry = (value) => {
    this.props.removeDistroListEntry(this.state.blossomID, value)
  }

  addDistroList = (value) => {
    this.props.addDistroListEntry(this.state.blossomID, value)
    this.handleReset()
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { location } = this.props
    const { location: nextLocation } = nextProps
    // method to see if the reports need to be refreshed
    if (
      location &&
      nextLocation &&
      nextLocation.pathname &&
      location.pathname &&
      nextLocation.pathname !== location.pathname
    ) {
      this.setState({ blossomID: nextProps.blossomIDFromParent })
      this.props.listDistroListData(nextProps.blossomIDFromParent)
    }
  }

  handleReset = () => {
    this.setState({
      distroListAddEntry: '',
    })
    this.setState({ distroListAddEntryError: true })
  }

  render() {
    const { classes, headerTitle, responseData, fetchingState } = this.props

    let groupTitle = ''
    let tableData = ''
    if (this.state.blossomID === 'bcp') {
      groupTitle = (
        <HeaderTitle title="TgtAlerts - BCP Distribution List Maintenance" />
      )
    } else if (this.state.blossomID === 'c3alert') {
      groupTitle = (
        <HeaderTitle title="TgtAlerts - C3 Distribution List Maintenance" />
      )
    } else if (this.state.blossomID === 'ceebackup') {
      groupTitle = (
        <HeaderTitle title="TgtAlerts - CEE Backup Distribution List Maintenance" />
      )
    } else if (this.state.blossomID === 'fmocdc') {
      groupTitle = (
        <HeaderTitle title="TgtAlerts - FMOC DC Distribution List Maintenance" />
      )
    } else if (this.state.blossomID === 'precall') {
      groupTitle = (
        <HeaderTitle title="TgtAlerts - Product Recall Distribution List Maintenance" />
      )
    } else if (this.state.blossomID === 'CI00598283') {
      groupTitle = (
        <HeaderTitle title="TgtAlerts - HR Distribution List Maintenance" />
      )
    } else if (this.state.blossomID === 'c3aalert') {
      groupTitle = (
        <HeaderTitle title="TgtAlerts - C3A Distribution List Maintenance" />
      )
    } else if (this.state.blossomID === 'developer') {
      groupTitle = (
        <HeaderTitle title="TgtAlerts - Developer Distribution List Maintenance" />
      )
    } else if (this.state.blossomID === 'shipt') {
      groupTitle = (
        <HeaderTitle title="TgtAlerts - Shipt Distribution List Maintenance" />
      )
    }
    if (responseData === '') {
      tableData = 'No data found in TOM Database'
    } else {
      tableData = (
        <DistributionListItems
          blossomIDFromParent={this.state.blossomID}
          dataFromParent={responseData}
          callbackFromParentData={this.removeDistroListEntry}
          fetchingState={fetchingState}
        />
      )
    }

    // Create variables from values of matching keys
    let toRender = <br />

    if (fetchingState === false && responseData == null) {
      toRender = <br />
    } else if (fetchingState === true) {
      toRender = (
        <div>
          <CircularProgress className={classes.spinner} thickness={7} />
          <h3>loading...</h3>
        </div>
      )
    } else if (responseData != null) {
      toRender = (
        <div className={classes.centerDiv}>
          <TextField
            id="filled-dl-input"
            label="Enter in Email Address"
            className={classes.textField}
            name="distroListAddEntry"
            InputLabelProps={{
              shrink: true,
            }}
            value={this.state.distroListAddEntry}
            onChange={this.handleChange.bind(this)}
            error={this.state.distroListAddEntryError}
          />
          <Button
            disabled={this.state.distroListAddEntryError}
            onClick={() => {
              this.addDistroList(this.state.distroListAddEntry)
            }}
            variant="contained"
            className={classes.button}
          >
            Add to Distribution List Table
          </Button>
          <br />
          {tableData}
        </div>
      )
    }

    return (
      <div className={classes.myBox}>
        {groupTitle}
        <Helmet>
          <title>{headerTitle}</title>
        </Helmet>
        <div className={classes.homePage}>
          <br />
          {toRender}
        </div>
      </div>
    )
  }
}

DistributionListMaintenancePage.propTypes = {}

// Review
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      distroListData,
      distroData,
      listDistroListData,
      addDistroListEntry,
      removeDistroListEntry,
    },
    dispatch,
  )

// Review
const mapStateToProps = (state) => ({
  distroListAddEntry: state.distroData.inputAddEntryData,
  responseData: state.distroData.data,
  fetchingState: state.distroData.fetching,
  fetching2State: state.distroData.fetching2,
  headerTitle: state.headerTitle,
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(DistributionListMaintenancePage))

DistributionListMaintenancePage.propTypes = {
  blossomIDFromParent: string.isRequired,
  tableName: string,
  deleteTableRow: func,
  listDistroListData: func,
  removeDistroListEntry: func,
  addDistroListEntry: func,
  location: shape({
    pathname: string,
  }),
  classes: object,
  headerTitle: string,
  responseData: arrayOf(
    shape({
      address: string,
    }),
  ),
  fetchingState: bool,
}
